(function () {
  'use strict';

  function revealImmediately(sections) {
    sections.forEach(function (section) {
      section.classList.add('is-revealed');
    });
  }

  function initTemplateReveal() {
    var body = document.body;
    if (!body || !body.classList.contains('has-template-reveal')) return;

    var sections = Array.prototype.slice.call(document.querySelectorAll('#MainContent > .shopify-section'));
    if (!sections.length) return;

    if (!('IntersectionObserver' in window)) {
      revealImmediately(sections);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, currentObserver) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          currentObserver.unobserve(entry.target);
        });
      },
      {
        root: null,
        threshold: 0.12,
        rootMargin: '0px 0px -8% 0px'
      }
    );

    sections.forEach(function (section, index) {
      if (index === 0) {
        section.classList.add('is-revealed');
        return;
      }
      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTemplateReveal);
  } else {
    initTemplateReveal();
  }

  document.addEventListener('shopify:section:load', initTemplateReveal);
})();
